export const imgUrl = process.env.REACT_APP_IMAGE_URL;
export const url = process.env.REACT_APP_BASE_URL;
export const capitalandUrl = 'https://www.capitaland.com';
